import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MassEmailStudent } from '../mass-email.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

@Component({
  selector: 'app-no-email-warning',
  templateUrl: './no-email-warning.component.html'

})
export class NoEmailWarningComponent implements OnInit, AfterViewInit {
  studentsWithoutRecipients: MassEmailStudent[] = [];
  retValNoEmailWarning: string;
  noEmailWarningDataSources = new TylerMatTableDataSource();
  @ViewChild(MatSort) sort1: MatSort;
  columnsToDisplay = ['StudentNumber', 'Name', 'GradeLevel'];
  constructor(
    public noEmailWarningDialogRef: MatDialogRef<NoEmailWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.studentsWithoutRecipients = this.data;
  }

  ngOnInit() {
    this.loadTableData();
  }
  ngAfterViewInit() {
  }

  loadTableData() {
    this.noEmailWarningDataSources.data = this.studentsWithoutRecipients;
    setTimeout(() => this.noEmailWarningDataSources.sort = this.sort1);
  }
  getAriaRow(row: MassEmailStudent): string {
    const colList: string[] = ['StudentNumber', 'Name', 'GradeLevel'];

    const dataList: string[] = [row.StudentNumber,
    row.Name,
    row.GradeLevel];
    return '';

  }

  backClick() {
    this.noEmailWarningDialogRef.close();
  }

  nextClick() {
    this.retValNoEmailWarning = 'Continue was clicked';
    this.noEmailWarningDialogRef.close(this.retValNoEmailWarning);
  }
}
